import { DeleteOutlined } from '@ant-design/icons';
import { Button, InputNumber, Popover } from 'antd';
import chroma from 'chroma-js';
import { ColorStep } from 'types/app.types';
import { ChromePicker, RGBColor } from 'react-color';
import { useContext } from 'react';
import { ThemeContext, ThemeContextType } from 'layout';
import styles from './index.module.scss';

const {
  wrapper, selectorWrapper, buttonWrapper, inputWrapper, dark,
} = styles;

interface ColorSelectorProps {
    colorStep: ColorStep,
    onChange: (colorStep: ColorStep) => void
    onDelete: () => void
}

function ColorSelector({ colorStep, onChange, onDelete }: ColorSelectorProps) {
  const { theme } = useContext<ThemeContextType>(ThemeContext);

  const currentColor = chroma(colorStep.color).rgba().reduce((acc, cur, index) => {
    if (index === 0) {
      acc.r = cur;
    }

    if (index === 1) {
      acc.g = cur;
    }

    if (index === 2) {
      acc.b = cur;
    }

    if (index === 3) {
      acc.a = cur;
    }

    return acc;
  }, {} as RGBColor);

  return (
    <div className={`${wrapper} ${theme === 'dark' ? dark : ''}`}>
      <div className={selectorWrapper}>
        <Popover
          destroyTooltipOnHide
          content={(
            <ChromePicker
              color={currentColor}
              onChangeComplete={(color) => {
                onChange({
                  ...colorStep,
                  color: Object.values(color.rgb),
                });
              }}
            />
)}
          title="Color Picker"
          trigger="click"
        >
          <div
            role="button"
            style={{ backgroundColor: chroma(colorStep.color).hex() }}
          >
            <span>{`${chroma(colorStep.color).hex()}`}</span>
          </div>
        </Popover>

      </div>
      <div className={inputWrapper}>
        <InputNumber
          placeholder="thres"
          value={colorStep.threshold}
          onChange={(value) => {
            onChange({
              ...colorStep,
              threshold: value || 0,
            });
          }}
        />
      </div>
      <div className={buttonWrapper}>
        <Button icon={<DeleteOutlined />} size="small" type="text" onClick={onDelete} />
      </div>
    </div>
  );
}

export default ColorSelector;
